import React, { useCallback, useEffect, useMemo } from 'react';
import FlatListItemCard from 'design-system/FlatListItemCard';
import useStyles from 'hooks/useStyles';
import { addTransactionToCache } from 'actions';
import createStyleSheets from 'utils/createStyleSheets';
import { selectAccountById } from 'reducers/selectors';
import { useAppDispatch, useAppSelector, useAppStore } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useOpenSearch } from 'features/transactions/hooks/useOpenSearch';
import { selectSearchTransactionsFormatted } from 'features/search/selectors';
import { useFetchSearchTransactionData } from 'hooks/useFetchSearchTransactionData';
import ListEmptyView from 'design-system/ListEmptyView';
import SectionHeader from 'features/invest/components/SectionHeader';
import { PHYSICAL_ASSET_TYPES } from 'features/accounts/constants';
import { selectShowNewPhysicalAssets } from 'features/accounts/selectors';
import RowTransaction from '../RowTransaction';
const NUMBER_TO_SHOW = 3;
const CustomCategoryTransactionsPreview = ({ category }) => {
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const fetchSearchData = useFetchSearchTransactionData();
    const openSearch = useOpenSearch();
    const search = useAppSelector(selectSearchTransactionsFormatted);
    const showNewPhysicalAssets = useAppSelector(selectShowNewPhysicalAssets);
    useEffect(() => {
        fetchSearchData();
    }, [fetchSearchData]);
    const transactions = useMemo(() => {
        const firstThreeTransactions = [];
        for (const t of search) {
            if (t.categoryId === category.id) {
                firstThreeTransactions.push({
                    ...t,
                    category: t.category ? t.category : category,
                });
            }
            if (firstThreeTransactions.length === NUMBER_TO_SHOW) {
                break;
            }
        }
        return firstThreeTransactions;
    }, [category, search]);
    const onPressTransaction = useCallback((item) => {
        dispatch(addTransactionToCache({ ...item, isCompact: true }));
        const account = selectAccountById(store.getState(), item.accountId);
        if (item.accountType &&
            PHYSICAL_ASSET_TYPES.has(item.accountType) &&
            account?.isManual &&
            showNewPhysicalAssets) {
            navigation.navigateDeprecated('EditValuationChange', {
                transactionId: item.id,
                accountId: item.accountId,
                accountType: item.accountType,
            });
        }
        else {
            navigation.push('Item', { id: item.id });
        }
    }, [showNewPhysicalAssets, store]);
    if (!transactions.length) {
        return (<>
        <SectionHeader title="Transactions"/>
        <ListEmptyView title="No transactions" onCard compact/>
      </>);
    }
    return (<>
      <SectionHeader title="Transactions" onSeeMorePress={() => openSearch({ filterType: 'CATEGORY', category })}/>
      {transactions.map((t, index, { length }) => (<FlatListItemCard index={index} itemsLength={length} style={styles.card} key={t.id}>
          <RowTransaction item={t} key={t.id} backgroundDark onPress={onPressTransaction}/>
        </FlatListItemCard>))}
    </>);
};
const styleSet = createStyleSheets((colors) => ({
    card: {
        backgroundColor: colors.cards.onDark,
    },
}));
export default CustomCategoryTransactionsPreview;
